/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { CustomerAddressesModel } from '../data/models';
import { convertKeysCase } from './convertCase';

type CustomAttributesType = {
  customAttributes?: { code: string; value: string }[];
};

export const transformDefaultValuesAddresses = (
  address?: CustomerAddressesModel & CustomAttributesType
): CustomerAddressesModel => {
  if (!address || !Array.isArray(address.customAttributes)) {
    return address ?? {};
  }

  const customAttributesObject: Record<string, string> = {};

  address?.customAttributes?.forEach((attr) => {
    if (attr.code && Object.hasOwn(attr, 'value')) {
      customAttributesObject[attr.code] = attr.value;
    }
  });

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { customAttributes, ...restOfObject } = address;

  return {
    ...restOfObject,
    ...convertKeysCase(customAttributesObject, 'camelCase', {}),
  };
};
